import { IRouteNode } from './route-node';
export interface Token {
  expiration: string;
  token: string;
  securityGroup: number;
  refreshToken: string;
  refreshTokenExpires: string;
  msClient: string;
  userId: number;
  routes: Map<string, string>;
  routeNodes: IRouteNode[];
  defaultLocation: string;
  application: string;
  mstarAdmin: boolean;
  generateGemboxInvoice: boolean;
  restrictedAgreementAccess: boolean;
  isTRWEnabled: boolean;
  trwToken: string | null;
  trwEmail: string | null;
}